/**
 * geo-switch.js
 *
 * Erkennt das Land des Besuchers per Cloudflare-IP-Lookup und blendet
 * Abschnitte mit data-country="XX" entsprechend ein oder aus.
 *
 * Markup-Regeln:
 *   data-country="ALL"     -> immer sichtbar
 *   data-country="DEFAULT" -> sichtbar, wenn kein anderer Abschnitt das erkannte Land trifft
 *   data-country="DE"      -> nur sichtbar bei Besuchern aus Deutschland
 *   ...
 *
 * Sichtbarkeit wird per inline display:none / display:revert gesteuert,
 * damit Theme-CSS nicht in die Quere kommt.
 * 
 * Verfügbare Länder werden in der featured-collections.liquid hinterlegt.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'visitor_country';
  var STORAGE_TS_KEY = 'visitor_country_ts';
  var TTL_MS = 30 * 60 * 1000; // 30 Minuten Cache

  function readCache() {
    try {
      var c = sessionStorage.getItem(STORAGE_KEY);
      var t = parseInt(sessionStorage.getItem(STORAGE_TS_KEY) || '0', 10);
      if (c && t && (Date.now() - t) < TTL_MS) return c;
    } catch (e) {}
    return null;
  }

  function writeCache(country) {
    try {
      sessionStorage.setItem(STORAGE_KEY, country);
      sessionStorage.setItem(STORAGE_TS_KEY, String(Date.now()));
    } catch (e) {}
  }

  function fetchCountry() {
    return fetch('https://www.cloudflare.com/cdn-cgi/trace', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var m = text.match(/loc=([A-Z]{2})/);
        return (m && m[1]) ? m[1] : 'DEFAULT';
      })
      .catch(function () { return 'DEFAULT'; });
  }

  function applyVisibility(country) {
    var elements = document.querySelectorAll('[data-country]');
    if (!elements.length) return;

    // Welche Länder sind überhaupt im DOM vertreten (außer ALL/DEFAULT)?
    var available = {};
    elements.forEach(function (el) {
      var c = (el.getAttribute('data-country') || '').toUpperCase();
      if (c && c !== 'ALL' && c !== 'DEFAULT') available[c] = true;
    });

    var target = available[country] ? country : 'DEFAULT';

    elements.forEach(function (el) {
      var c = (el.getAttribute('data-country') || 'ALL').toUpperCase();
      var show;
      if (c === 'ALL')          show = true;
      else if (c === 'DEFAULT') show = (target === 'DEFAULT');
      else                      show = (c === target);

      el.style.display = show ? '' : 'none';
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  function run() {
    var cached = readCache();
    if (cached) {
      applyVisibility(cached);
      return;
    }
    // Beim ersten Aufruf: alle nicht-ALL Abschnitte vorerst verstecken,
    // bis wir das Land kennen – verhindert kurzes Aufblitzen.
    document.querySelectorAll('[data-country]').forEach(function (el) {
      var c = (el.getAttribute('data-country') || '').toUpperCase();
      if (c !== 'ALL') el.style.display = 'none';
    });

    fetchCountry().then(function (country) {
      writeCache(country);
      applyVisibility(country);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
